module.exports = __webpack_public_path__ + "img/logo.5874aa0c.png";